import { render } from "./FlotasView.vue?vue&type=template&id=338cfa11&scoped=true"
import script from "./FlotasView.vue?vue&type=script&lang=js"
export * from "./FlotasView.vue?vue&type=script&lang=js"

import "./FlotasView.vue?vue&type=style&index=0&id=338cfa11&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338cfa11"]])

export default __exports__